/* eslint-disable no-underscore-dangle */
import { createStore, compose, applyMiddleware } from "redux";
import createSagaMiddleware from "redux-saga";
import { composeWithDevTools } from "redux-devtools-extension";
import { persistStore, persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import reducers from "./ducks";
import sagas from "./sagas";

const persistConfig = {
  key: "root",
  storage,
  whitelist: ["status", "user"],
};

const persistedReducer = persistReducer(persistConfig, reducers);

const sagaMiddleware = createSagaMiddleware();
const middlewares = [sagaMiddleware];
const composer = compose(applyMiddleware(...middlewares));

export const store = createStore(
  persistedReducer,
  composeWithDevTools(composer)
);
export const persistor = persistStore(store);

sagaMiddleware.run(sagas);

window.store = process.env.NODE_ENV !== "production" && store;
